module.exports = __webpack_public_path__ + "static/media/mike_page.b8da1f1e.png";